// src/context/AuthContext.js
import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Initialize from localStorage (for hard reloads)
  const [token, setTokenState] = useState(() => {
    try {
      return localStorage.getItem('access_token');
    } catch {
      return null;
    }
  });

  const setToken = (newToken) => {
    try {
      if (newToken) {
        localStorage.setItem('access_token', newToken);
      } else {
        localStorage.removeItem('access_token');
      }
    } catch (e) {
      console.error('[Auth] Failed to write token to localStorage', e);
    }
    setTokenState(newToken || null);
  };

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within <AuthProvider>');
  }
  return ctx;
}
